import React from "react";

import clsx from "clsx";

import { GenericTooltip } from "@components/tooltip-container";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { useDesignElementManager } from "@hooks/use-design-element-manager";
import { PLATFORM_NORTHBEAM } from "@north-beam/nb-common";

import { type RebudgetingTableRow } from "../mid-cycle-rebudgeting-table";

export const SpendChannelNameCellFormatter = ({
  row: _row,
}: DataTypeProvider.ValueFormatterProps) => {
  const row = _row as RebudgetingTableRow;
  const { designElementManager } = useDesignElementManager();

  const naming = row.displayName;

  const shouldDrawIcons = !!row.metadata.breakdowns[PLATFORM_NORTHBEAM];

  const iconKey = row.metadata.breakdowns[PLATFORM_NORTHBEAM] ?? "";
  const icon = designElementManager.getDesignElement(iconKey).getComponent({
    size: "20px",
  });

  return (
    <div className="flex flex-col justify-center h-full relative pl-3 border-r-0">
      <div className="flex items-center space-x-2 font-semibold font-sans truncate">
        {shouldDrawIcons && icon}
        <div className={clsx("truncate")}>
          <div
            className={clsx(
              "font-sans text-[0.5rem] text-interstellar-1 leading-3 uppercase truncate",
              {
                "mb-1": true,
              },
            )}
          ></div>
          <GenericTooltip content={naming} mouseEnterDelay={1000} noInfoCircle>
            <div className="text-cosmic+3 no-underline hover:text-cosmic+2 truncate cursor-default">
              <span>{naming}</span>
            </div>
          </GenericTooltip>
        </div>
      </div>
    </div>
  );
};
